module.exports = __webpack_public_path__ + "media/components/theme/fonts/icomoon-ff1325a4e3858883cfdd9c169c50ee47.svg";